const collapsibles = document.querySelectorAll(".collapsible");

collapsibles.forEach((item) =>
  item.addEventListener("click", function () {
    // Close all collapsibles except the one that was clicked
    collapsibles.forEach((collapsible) => {
      if (collapsible !== item) {
        collapsible.classList.remove("collapsible--expanded");
      }
    });

    // Toggle the clicked collapsible
    this.classList.toggle("collapsible--expanded");
  })
);

document.addEventListener('DOMContentLoaded', function() {
  AOS.init({
    once: true
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const videoElement = document.getElementById('butlerVideo');
  
  // Define the intersection observer options
  const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: [0.75, 1.0] // Watch for 75% and 100% visibility
  };

  let isPlaying = false; // Track the play state

  // Create an intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= 0.75) {
        if (!isPlaying) {
          videoElement.play();
          isPlaying = true;
          console.log('Video started playing.');
        }
      } else if (entry.intersectionRatio === 0) {
        if (isPlaying) {
          videoElement.pause();
          isPlaying = false;
          console.log('Video paused.');
        }
      }
    });
  }, observerOptions);

  // Observe the video element
  observer.observe(videoElement);
});


document.addEventListener("DOMContentLoaded", function() {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedPackage = urlParams.get('package');

  if (selectedPackage) {
    document.getElementById('package').value = selectedPackage.replace(/-/g, ' ');
  }
});